<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <ckeditor
            :value="value || ''"
            :editor="editor"
            :config="editorConfig"
            @input="emitValue($event)"
        ></ckeditor>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
    name: 'RichTextField',
    mixins: [FieldMixin],
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: ['bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo']
                }
            }
        }
    }
}
</script>
